module.exports = __webpack_public_path__ + "static/media/Studies-image.892f7c6f.jpg";